import Iconify from "src/components/Iconify"



const LabelFromAction = ({ children }) => {
    return (
      <div className="flex items-center space-x-2">
        <Iconify icon="mdi:arrow-right-bold" />
        <span>{children}</span>
      </div>
    )}

export default LabelFromAction;